module.exports = __webpack_public_path__ + "static/sport/logo.6f115ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 0